import React from 'react';

export const DIVIDER = 'divider' as const;

type IconProps = {
  size?: number;
  color?: string;
};

export type SidebarLink = {
  label: string;
  href: string;
  icon?: React.ComponentType<IconProps>;
  count?: number;
  children?: SidebarItem[];
  defaultExpanded?: boolean;
};

export type SidebarItem = SidebarLink | typeof DIVIDER;
